module.exports = __webpack_public_path__ + "media/images/icons/fullscreen-enter-eddf1ad6ffa3ceef9b4ba5fcfb443219.svg";